import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
export class ProfileEditAjaxEndPoints {
    static async updateUsername(newUsername, shouldPurchaseIfNoAttemptsLeft = false) {
        const urlVariable = 'username';
        const data = {
            username: newUsername,
            shouldPurchaseIfNoAttemptsLeft: shouldPurchaseIfNoAttemptsLeft
        };
        return this.updateProfile(urlVariable, data);
    }
    static async getUsernameChangeInfo() {
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiUsernameChangeInfo());
        if (response == undefined) return undefined;
        return response.json;
    }
    static async getEditProfileInfo() {
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiEditProfileInfo());
        if (response == undefined) return undefined;
        return response.json;
    }
    static async updatePreferredColor(preferredColor) {
        const urlVariable = 'preferred-color';
        const data = {
            preferredColor: preferredColor
        };
        await this.updateProfile(urlVariable, data);
    }
    static async updateIcon(icon) {
        const urlVariable = 'icon';
        const data = {
            icon: icon
        };
        await this.updateProfile(urlVariable, data);
    }
    static async updateProfile(urlVariable, data) {
        const response = await UIAjaxWrapper.postRequestHandler(`${UIAPIEndpoints.apiUpdateProfile()}/${urlVariable}`, undefined, data, this.contentType);
        if (response == undefined) return false;
        return true;
    }
}
ProfileEditAjaxEndPoints.contentType = 'application/json';
